import React from "react";

export const Home = () => {
	return (
		<React.Fragment>
			<p>This site is dedicated to Ida and Eddie, two Chicagoans that married and lived in the later half of the 19th Century.</p>
			<img className="hero-image" src="./img/Edward Vandenburgh Ida Shreffler Marriage 1875.jpg" alt="Ida and Eddie's Marriage Certificate." />
		</React.Fragment>
	);
}
